import { render, staticRenderFns } from "./LhcKniha.vue?vue&type=template&id=84665772&"
import script from "./LhcKniha.vue?vue&type=script&lang=js&"
export * from "./LhcKniha.vue?vue&type=script&lang=js&"
import style0 from "./LhcKniha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports